"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[400],{

/***/ 79846:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Checkbox_Checkbox; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@mui/base/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(77597);
// EXTERNAL MODULE: ../../node_modules/@mui/system/esm/colorManipulator.js
var colorManipulator = __webpack_require__(47591);
// EXTERNAL MODULE: ../../node_modules/@mui/material/internal/SwitchBase.js + 1 modules
var SwitchBase = __webpack_require__(81469);
// EXTERNAL MODULE: ../../node_modules/@mui/material/utils/createSvgIcon.js
var createSvgIcon = __webpack_require__(50110);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../node_modules/@mui/material/internal/svg-icons/CheckBoxOutlineBlank.js


/**
 * @ignore - internal component.
 */ 
/* harmony default export */ var CheckBoxOutlineBlank = ((0,createSvgIcon/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
    d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), 'CheckBoxOutlineBlank'));

;// CONCATENATED MODULE: ../../node_modules/@mui/material/internal/svg-icons/CheckBox.js


/**
 * @ignore - internal component.
 */ 
/* harmony default export */ var CheckBox = ((0,createSvgIcon/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
    d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), 'CheckBox'));

;// CONCATENATED MODULE: ../../node_modules/@mui/material/internal/svg-icons/IndeterminateCheckBox.js


/**
 * @ignore - internal component.
 */ 
/* harmony default export */ var IndeterminateCheckBox = ((0,createSvgIcon/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), 'IndeterminateCheckBox'));

// EXTERNAL MODULE: ../../node_modules/@mui/material/utils/capitalize.js + 1 modules
var capitalize = __webpack_require__(45673);
// EXTERNAL MODULE: ../../node_modules/@mui/material/styles/useThemeProps.js + 1 modules
var useThemeProps = __webpack_require__(64117);
// EXTERNAL MODULE: ../../node_modules/@mui/material/styles/styled.js + 2 modules
var styled = __webpack_require__(70977);
// EXTERNAL MODULE: ../../node_modules/@mui/base/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(72606);
// EXTERNAL MODULE: ../../node_modules/@mui/base/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(98922);
;// CONCATENATED MODULE: ../../node_modules/@mui/material/Checkbox/checkboxClasses.js

function getCheckboxUtilityClass(slot) {
    return (0,generateUtilityClass/* default */.Z)('MuiCheckbox', slot);
}
var checkboxClasses = (0,generateUtilityClasses/* default */.Z)('MuiCheckbox', [
    'root',
    'checked',
    'disabled',
    'indeterminate',
    'colorPrimary',
    'colorSecondary'
]);
/* harmony default export */ var Checkbox_checkboxClasses = (checkboxClasses);

;// CONCATENATED MODULE: ../../node_modules/@mui/material/Checkbox/Checkbox.js
















function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var _excluded = [
    "checkedIcon",
    "color",
    "icon",
    "indeterminate",
    "indeterminateIcon",
    "inputProps",
    "size"
];
var useUtilityClasses = function(ownerState) {
    var classes = ownerState.classes, indeterminate = ownerState.indeterminate, color = ownerState.color;
    var slots = {
        root: [
            'root',
            indeterminate && 'indeterminate',
            "color".concat((0,capitalize/* default */.Z)(color))
        ]
    };
    var composedClasses = (0,composeClasses/* default */.Z)(slots, getCheckboxUtilityClass, classes);
    return (0,esm_extends/* default */.Z)({}, classes, composedClasses);
};
var CheckboxRoot = (0,styled/* default */.ZP)(SwitchBase/* default */.Z, {
    shouldForwardProp: function(prop) {
        return (0,styled/* rootShouldForwardProp */.FO)(prop) || prop === 'classes';
    },
    name: 'MuiCheckbox',
    slot: 'Root',
    overridesResolver: function(props, styles) {
        var ownerState = props.ownerState;
        return [
            styles.root,
            ownerState.indeterminate && styles.indeterminate,
            ownerState.color !== 'default' && styles["color".concat((0,capitalize/* default */.Z)(ownerState.color))]
        ];
    }
})(function(param) {
    var theme = param.theme, ownerState = param.ownerState;
    var _obj;
    return (0,esm_extends/* default */.Z)({
        color: theme.palette.text.secondary
    }, !ownerState.disableRipple && {
        '&:hover': {
            backgroundColor: (0,colorManipulator/* alpha */.Fq)(ownerState.color === 'default' ? theme.palette.action.active : theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }
    }, ownerState.color !== 'default' && (_obj = {}, _defineProperty(_obj, "&.".concat(Checkbox_checkboxClasses.checked, ", &.").concat(Checkbox_checkboxClasses.indeterminate), {
        color: theme.palette[ownerState.color].main
    }), _defineProperty(_obj, "&.".concat(Checkbox_checkboxClasses.disabled), {
        color: theme.palette.action.disabled
    }), _obj));
});
var defaultCheckedIcon = /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckBox, {});
var defaultIcon = /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckBoxOutlineBlank, {});
var defaultIndeterminateIcon = /*#__PURE__*/ (0,jsx_runtime.jsx)(IndeterminateCheckBox, {});
var Checkbox = /*#__PURE__*/ react.forwardRef(function Checkbox(inProps, ref) {
    var _icon$props$fontSize, _indeterminateIcon$pr;
    var props = (0,useThemeProps/* default */.Z)({
        props: inProps,
        name: 'MuiCheckbox'
    });
    var _checkedIcon = props.checkedIcon, checkedIcon = _checkedIcon === void 0 ? defaultCheckedIcon : _checkedIcon, _color = props.color, color = _color === void 0 ? 'primary' : _color, tmp = props.icon, iconProp = tmp === void 0 ? defaultIcon : tmp, _indeterminate = props.indeterminate, indeterminate = _indeterminate === void 0 ? false : _indeterminate, tmp1 = props.indeterminateIcon, indeterminateIconProp = tmp1 === void 0 ? defaultIndeterminateIcon : tmp1, inputProps = props.inputProps, _size = props.size, size = _size === void 0 ? 'medium' : _size, other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
    var icon = indeterminate ? indeterminateIconProp : iconProp;
    var indeterminateIcon = indeterminate ? indeterminateIconProp : checkedIcon;
    var ownerState = (0,esm_extends/* default */.Z)({}, props, {
        color: color,
        indeterminate: indeterminate,
        size: size
    });
    var classes = useUtilityClasses(ownerState);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(CheckboxRoot, (0,esm_extends/* default */.Z)({
        type: "checkbox",
        inputProps: (0,esm_extends/* default */.Z)({
            'data-indeterminate': indeterminate
        }, inputProps),
        icon: /*#__PURE__*/ react.cloneElement(icon, {
            fontSize: (_icon$props$fontSize = icon.props.fontSize) != null ? _icon$props$fontSize : size
        }),
        checkedIcon: /*#__PURE__*/ react.cloneElement(indeterminateIcon, {
            fontSize: (_indeterminateIcon$pr = indeterminateIcon.props.fontSize) != null ? _indeterminateIcon$pr : size
        }),
        ownerState: ownerState,
        ref: ref
    }, other, {
        classes: classes
    })));
});
 false ? 0 : void 0;
/* harmony default export */ var Checkbox_Checkbox = (Checkbox);


/***/ }),

/***/ 53055:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

/**
 * @ignore - internal component.
 */ var FormControlContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createContext();
if (false) {}
/* harmony default export */ __webpack_exports__["Z"] = (FormControlContext);


/***/ }),

/***/ 63055:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ formControlState; }
/* harmony export */ });
function formControlState(param) {
    var props = param.props, states = param.states, muiFormControl = param.muiFormControl;
    return states.reduce(function(acc, state) {
        acc[state] = props[state];
        if (muiFormControl) {
            if (typeof props[state] === 'undefined') {
                acc[state] = muiFormControl[state];
            }
        }
        return acc;
    }, {});
};


/***/ }),

/***/ 45054:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useFormControl; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _FormControlContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53055);


function useFormControl() {
    return react__WEBPACK_IMPORTED_MODULE_0__.useContext(_FormControlContext__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);
};


/***/ }),

/***/ 3933:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ FormControlLabel_FormControlLabel; }
});

// UNUSED EXPORTS: FormControlLabelRoot

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6277);
// EXTERNAL MODULE: ../../node_modules/@mui/base/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(77597);
// EXTERNAL MODULE: ../../node_modules/@mui/material/FormControl/useFormControl.js
var useFormControl = __webpack_require__(45054);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(42224);
// EXTERNAL MODULE: ../../node_modules/@mui/material/utils/capitalize.js + 1 modules
var capitalize = __webpack_require__(45673);
// EXTERNAL MODULE: ../../node_modules/@mui/material/styles/styled.js + 2 modules
var styled = __webpack_require__(70977);
// EXTERNAL MODULE: ../../node_modules/@mui/material/styles/useThemeProps.js + 1 modules
var useThemeProps = __webpack_require__(64117);
// EXTERNAL MODULE: ../../node_modules/@mui/base/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(72606);
// EXTERNAL MODULE: ../../node_modules/@mui/base/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(98922);
;// CONCATENATED MODULE: ../../node_modules/@mui/material/FormControlLabel/formControlLabelClasses.js

function getFormControlLabelUtilityClasses(slot) {
    return (0,generateUtilityClass/* default */.Z)('MuiFormControlLabel', slot);
}
var formControlLabelClasses = (0,generateUtilityClasses/* default */.Z)('MuiFormControlLabel', [
    'root',
    'labelPlacementStart',
    'labelPlacementTop',
    'labelPlacementBottom',
    'disabled',
    'label',
    'error'
]);
/* harmony default export */ var FormControlLabel_formControlLabelClasses = (formControlLabelClasses);

// EXTERNAL MODULE: ../../node_modules/@mui/material/FormControl/formControlState.js
var formControlState = __webpack_require__(63055);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../node_modules/@mui/material/FormControlLabel/FormControlLabel.js
















function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var _excluded = [
    "checked",
    "className",
    "componentsProps",
    "control",
    "disabled",
    "disableTypography",
    "inputRef",
    "label",
    "labelPlacement",
    "name",
    "onChange",
    "value"
];
var useUtilityClasses = function(ownerState) {
    var classes = ownerState.classes, disabled = ownerState.disabled, labelPlacement = ownerState.labelPlacement, error = ownerState.error;
    var slots = {
        root: [
            'root',
            disabled && 'disabled',
            "labelPlacement".concat((0,capitalize/* default */.Z)(labelPlacement)),
            error && 'error'
        ],
        label: [
            'label',
            disabled && 'disabled'
        ]
    };
    return (0,composeClasses/* default */.Z)(slots, getFormControlLabelUtilityClasses, classes);
};
var FormControlLabelRoot = (0,styled/* default */.ZP)('label', {
    name: 'MuiFormControlLabel',
    slot: 'Root',
    overridesResolver: function(props, styles) {
        var ownerState = props.ownerState;
        return [
            _defineProperty({}, "& .".concat(FormControlLabel_formControlLabelClasses.label), styles.label),
            styles.root,
            styles["labelPlacement".concat((0,capitalize/* default */.Z)(ownerState.labelPlacement))]
        ];
    }
})(function(param) {
    var theme = param.theme, ownerState = param.ownerState;
    return (0,esm_extends/* default */.Z)(// used for row presentation of radio/checkbox
    _defineProperty({
        display: 'inline-flex',
        alignItems: 'center',
        cursor: 'pointer',
        // For correct alignment with the text.
        verticalAlign: 'middle',
        WebkitTapHighlightColor: 'transparent',
        marginLeft: -11,
        marginRight: 16
    }, "&.".concat(FormControlLabel_formControlLabelClasses.disabled), {
        cursor: 'default'
    }), ownerState.labelPlacement === 'start' && {
        flexDirection: 'row-reverse',
        marginLeft: 16,
        // used for row presentation of radio/checkbox
        marginRight: -11
    }, ownerState.labelPlacement === 'top' && {
        flexDirection: 'column-reverse',
        marginLeft: 16
    }, ownerState.labelPlacement === 'bottom' && {
        flexDirection: 'column',
        marginLeft: 16
    }, _defineProperty({}, "& .".concat(FormControlLabel_formControlLabelClasses.label), _defineProperty({}, "&.".concat(FormControlLabel_formControlLabelClasses.disabled), {
        color: theme.palette.text.disabled
    })));
});
/**
 * Drop-in replacement of the `Radio`, `Switch` and `Checkbox` component.
 * Use this component if you want to display an extra label.
 */ var FormControlLabel = /*#__PURE__*/ react.forwardRef(function FormControlLabel(inProps, ref) {
    var props = (0,useThemeProps/* default */.Z)({
        props: inProps,
        name: 'MuiFormControlLabel'
    });
    var className = props.className, _componentsProps = props.componentsProps, componentsProps = _componentsProps === void 0 ? {} : _componentsProps, control = props.control, disabledProp = props.disabled, disableTypography = props.disableTypography, label = props.label, _labelPlacement = props.labelPlacement, labelPlacement = _labelPlacement === void 0 ? 'end' : _labelPlacement, other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
    var muiFormControl = (0,useFormControl/* default */.Z)();
    var disabled = disabledProp;
    if (typeof disabled === 'undefined' && typeof control.props.disabled !== 'undefined') {
        disabled = control.props.disabled;
    }
    if (typeof disabled === 'undefined' && muiFormControl) {
        disabled = muiFormControl.disabled;
    }
    var controlProps = {
        disabled: disabled
    };
    [
        'checked',
        'name',
        'onChange',
        'value',
        'inputRef'
    ].forEach(function(key) {
        if (typeof control.props[key] === 'undefined' && typeof props[key] !== 'undefined') {
            controlProps[key] = props[key];
        }
    });
    var fcs = (0,formControlState/* default */.Z)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'error'
        ]
    });
    var ownerState = (0,esm_extends/* default */.Z)({}, props, {
        disabled: disabled,
        label: label,
        labelPlacement: labelPlacement,
        error: fcs.error
    });
    var classes = useUtilityClasses(ownerState);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControlLabelRoot, (0,esm_extends/* default */.Z)({
        className: (0,clsx_m/* default */.Z)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ react.cloneElement(control, controlProps),
            label.type === Typography/* default */.Z || disableTypography ? label : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, (0,esm_extends/* default */.Z)({
                component: "span",
                className: classes.label
            }, componentsProps.typography, {
                children: label
            }))
        ]
    })));
});
 false ? 0 : void 0;
/* harmony default export */ var FormControlLabel_FormControlLabel = (FormControlLabel);


/***/ }),

/***/ 81469:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ internal_SwitchBase; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6277);
// EXTERNAL MODULE: ../../node_modules/@mui/base/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(77597);
// EXTERNAL MODULE: ../../node_modules/@mui/material/utils/capitalize.js + 1 modules
var capitalize = __webpack_require__(45673);
// EXTERNAL MODULE: ../../node_modules/@mui/material/styles/styled.js + 2 modules
var styled = __webpack_require__(70977);
// EXTERNAL MODULE: ../../node_modules/@mui/material/utils/useControlled.js + 1 modules
var useControlled = __webpack_require__(87876);
// EXTERNAL MODULE: ../../node_modules/@mui/material/FormControl/useFormControl.js
var useFormControl = __webpack_require__(45054);
// EXTERNAL MODULE: ../../node_modules/@mui/material/ButtonBase/ButtonBase.js + 1 modules
var ButtonBase = __webpack_require__(38106);
// EXTERNAL MODULE: ../../node_modules/@mui/base/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(72606);
// EXTERNAL MODULE: ../../node_modules/@mui/base/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(98922);
;// CONCATENATED MODULE: ../../node_modules/@mui/material/internal/switchBaseClasses.js

function getSwitchBaseUtilityClass(slot) {
    return (0,generateUtilityClass/* default */.Z)('PrivateSwitchBase', slot);
}
var switchBaseClasses = (0,generateUtilityClasses/* default */.Z)('PrivateSwitchBase', [
    'root',
    'checked',
    'disabled',
    'input',
    'edgeStart',
    'edgeEnd'
]);
/* harmony default export */ var internal_switchBaseClasses = ((/* unused pure expression or super */ null && (switchBaseClasses)));

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../node_modules/@mui/material/internal/SwitchBase.js















function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var _excluded = [
    "autoFocus",
    "checked",
    "checkedIcon",
    "className",
    "defaultChecked",
    "disabled",
    "disableFocusRipple",
    "edge",
    "icon",
    "id",
    "inputProps",
    "inputRef",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "readOnly",
    "required",
    "tabIndex",
    "type",
    "value"
];
var useUtilityClasses = function(ownerState) {
    var classes = ownerState.classes, checked = ownerState.checked, disabled = ownerState.disabled, edge = ownerState.edge;
    var slots = {
        root: [
            'root',
            checked && 'checked',
            disabled && 'disabled',
            edge && "edge".concat((0,capitalize/* default */.Z)(edge))
        ],
        input: [
            'input'
        ]
    };
    return (0,composeClasses/* default */.Z)(slots, getSwitchBaseUtilityClass, classes);
};
var SwitchBaseRoot = (0,styled/* default */.ZP)(ButtonBase/* default */.Z)(function(param) {
    var ownerState = param.ownerState;
    return (0,esm_extends/* default */.Z)({
        padding: 9,
        borderRadius: '50%'
    }, ownerState.edge === 'start' && {
        marginLeft: ownerState.size === 'small' ? -3 : -12
    }, ownerState.edge === 'end' && {
        marginRight: ownerState.size === 'small' ? -3 : -12
    });
});
var SwitchBaseInput = (0,styled/* default */.ZP)('input')({
    cursor: 'inherit',
    position: 'absolute',
    opacity: 0,
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    margin: 0,
    padding: 0,
    zIndex: 1
});
/**
 * @ignore - internal component.
 */ var SwitchBase = /*#__PURE__*/ react.forwardRef(function SwitchBase(props, ref) {
    var autoFocus = props.autoFocus, checkedProp = props.checked, checkedIcon = props.checkedIcon, className = props.className, defaultChecked = props.defaultChecked, disabledProp = props.disabled, _disableFocusRipple = props.disableFocusRipple, disableFocusRipple = _disableFocusRipple === void 0 ? false : _disableFocusRipple, _edge = props.edge, edge = _edge === void 0 ? false : _edge, icon = props.icon, id = props.id, inputProps = props.inputProps, inputRef = props.inputRef, name = props.name, onBlur = props.onBlur, onChange = props.onChange, onFocus = props.onFocus, readOnly = props.readOnly, required = props.required, tabIndex = props.tabIndex, type = props.type, value = props.value, other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
    var ref1 = _slicedToArray((0,useControlled/* default */.Z)({
        controlled: checkedProp,
        default: Boolean(defaultChecked),
        name: 'SwitchBase',
        state: 'checked'
    }), 2), checked = ref1[0], setCheckedState = ref1[1];
    var muiFormControl = (0,useFormControl/* default */.Z)();
    var handleFocus = function(event) {
        if (onFocus) {
            onFocus(event);
        }
        if (muiFormControl && muiFormControl.onFocus) {
            muiFormControl.onFocus(event);
        }
    };
    var handleBlur = function(event) {
        if (onBlur) {
            onBlur(event);
        }
        if (muiFormControl && muiFormControl.onBlur) {
            muiFormControl.onBlur(event);
        }
    };
    var handleInputChange = function(event) {
        // Workaround for https://github.com/facebook/react/issues/9023
        if (event.nativeEvent.defaultPrevented) {
            return;
        }
        var newChecked = event.target.checked;
        setCheckedState(newChecked);
        if (onChange) {
            // TODO v6: remove the second argument.
            onChange(event, newChecked);
        }
    };
    var disabled = disabledProp;
    if (muiFormControl) {
        if (typeof disabled === 'undefined') {
            disabled = muiFormControl.disabled;
        }
    }
    var hasLabelFor = type === 'checkbox' || type === 'radio';
    var ownerState = (0,esm_extends/* default */.Z)({}, props, {
        checked: checked,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        edge: edge
    });
    var classes = useUtilityClasses(ownerState);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(SwitchBaseRoot, (0,esm_extends/* default */.Z)({
        component: "span",
        className: (0,clsx_m/* default */.Z)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        tabIndex: null,
        role: undefined,
        onFocus: handleFocus,
        onBlur: handleBlur,
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SwitchBaseInput, (0,esm_extends/* default */.Z)({
                autoFocus: autoFocus,
                checked: checkedProp,
                defaultChecked: defaultChecked,
                className: classes.input,
                disabled: disabled,
                id: hasLabelFor && id,
                name: name,
                onChange: handleInputChange,
                readOnly: readOnly,
                ref: inputRef,
                required: required,
                ownerState: ownerState,
                tabIndex: tabIndex,
                type: type
            }, type === 'checkbox' && value === undefined ? {} : {
                value: value
            }, inputProps)),
            checked ? checkedIcon : icon
        ]
    })));
}); // NB: If changed, please update Checkbox, Switch and Radio
// so that the API documentation is updated.
 false ? 0 : void 0;
/* harmony default export */ var internal_SwitchBase = (SwitchBase);


/***/ })

}]);